import { Component, OnInit } from '@angular/core';
import { HeaderNewComponent } from '../header/header-new.component';
import { fromEvent, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
import { KeycloakService } from 'keycloak-angular';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ResetAllStates } from 'src/app/state/reset.reducer';
import { FooterComponent } from '../footer/footer.component';

@Component({
  selector: 'app-rejection',
  standalone: true,
  imports: [HeaderNewComponent,FooterComponent],
  templateUrl: './rejection.component.html',
  styleUrl: './rejection.component.scss'
})
export class RejectionComponent implements OnInit {
    productName: any;
  private unsubscriber: Subject<void> = new Subject<void>();
   constructor(
    private store: Store,
    private keycloak: KeycloakService,
    private sessionStorage: SessionStorageService,

  ) {}


  ngOnInit(): void {
      history.pushState(null, '');

    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, '');
      });
        this.productName = this.sessionStorage.getProductName();
  }

   onCloseClicked() {
     sessionStorage.clear();
     this.store.dispatch(new ResetAllStates());
     this.keycloak.logout(window.location.origin);
      window.location.href = 'https://www.bawag.at';
  }

  ngOnDestroy() {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }

}
